import { useEffect, useState } from 'react';

/**
 * Tracks an in-progress external redirect (e.g. Stripe). Resets automatically if the
 * browser restores this page from bfcache after the user navigates back.
 */
export const useRedirectPending = () => {
	const [isRedirecting, setIsRedirecting] = useState(false);

	useEffect(() => {
		const handle = (e: PageTransitionEvent) => {
			if (e.persisted) setIsRedirecting(false);
		};
		window.addEventListener('pageshow', handle);
		return () => window.removeEventListener('pageshow', handle);
	}, []);

	return { isRedirecting, setIsRedirecting };
};
